import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { Profile } from "./interfaces/profile";
import { GlobalFunction } from "../../../../routes/services/globalFuntion";
import { PermissionsService } from "../../../../routes/services/permissions.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UsersService } from "../../../../routes/services/users.service";
import { ClientsService } from "../../../../routes/services/clients.service";
import { SubClientsService } from "../../../../routes/services/subclients.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.html",
  styleUrls: ["./profile.scss"]
})
export class ProfileComponent implements OnInit {
  @Input() user: Profile | null = null;
  @Output() submitProfile = new EventEmitter();
  groups = [];
  edit: boolean = false;

  logo = "";
  logoBase64: String = "";

  userForm: FormGroup = new FormGroup({
    first_name: new FormControl("", Validators.required),
    last_name: new FormControl("", Validators.required),
    email: new FormControl("", Validators.required)
  });
  temporal_email = "";
  constructor(
    public globalFunction: GlobalFunction,
    public PermissionsService: PermissionsService,
    public userService: UsersService,
    public clientService: ClientsService,
    public subclientService: SubClientsService,
    public router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["user"]) {
      this.setValueUser();
    }
  }
  ngOnInit(): void {
    this.setValueUser();
  }
  setValueUser() {
    if (this.user) {
      this.userForm.setValue({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email
      });
      this.temporal_email = this.user.email;
      this.logo = this.validateImage(this.user);
    }
    this.PermissionsService.getGroups(``).subscribe((resp) => {
      this.groups = resp || [];
    });
  }
  getbase64(event: String) {
    this.logoBase64 = event;
  }
  submitForm() {
    let obj: any = { user: { ...this.userForm.value }, logo: this.logoBase64 };
    if (this.temporal_email === obj.user.email) {
      delete obj.user.email;
    }
    if (!this.logoBase64) {
      delete obj["logo"];
    }
    if (this.user) {
      if (this.user.is_subclient) {
        this.subclientService.patchSubClient(this.user.subclient.id, obj).subscribe((resp) => {
          this.edit = false;
          this.submitProfile.emit(resp);
        });
      } else if (!this.user.is_subclient) {
        this.clientService.patchClient(this.user?.client.id, obj).subscribe((resp) => {
          this.edit = false;
          this.submitProfile.emit(resp);
        });
      }
    }
  }
  /**
   * Cierra el modal de perfil y navega al historial de pagos del cliente.
   * @returns void
   */
  goToPaymentHistory(): void {
    this.globalFunction.Modal(null, "hide");
    this.router.navigate(["/historial-pagos"]);
  }
  /**
   * Cierra el modal de perfil y navega a las tarjetas guardadas del cliente.
   * @returns void
   */
  goToPaymentMethods(): void {
    this.globalFunction.Modal(null, "hide");
    this.router.navigate(["/tarjetas"]);
  }
  /**
   * Obtiene la clase de color del indicador segun el estado de la suscripcion.
   * @returns Clase CSS del indicador de estado.
   */
  getPlanStatusClass(): string {
    const status = this.user && this.user.subscription ? this.user.subscription.status : null;
    if (status === "active" || status === "trailing") {
      return "plan-status-active";
    }
    if (status === "canceled" || status === "incomplete_expired") {
      return "plan-status-canceled";
    }
    if (status === "paused") {
      return "plan-status-paused";
    }
    return "plan-status-pending";
  }

  /**
   * Obtiene la clave de traduccion del estado de la suscripcion.
   * @returns Clave i18n del estado.
   */
  getPlanStatusKey(): string {
    const status = this.user && this.user.subscription ? this.user.subscription.status : "";
    return `topbar.profile.plan-status.${status}`;
  }

  /**
   * Obtiene la clave de traduccion del intervalo de cobro del plan.
   * @returns Clave i18n de "mes" o "ano".
   */
  getPlanIntervalKey(): string {
    const price = this.user && this.user.subscription ? this.user.subscription.price : null;
    return price && price.interval === "year"
      ? "topbar.profile.per-year"
      : "topbar.profile.per-month";
  }

  /**
   * Obtiene la leyenda del fin de periodo: se cancela o se renueva en esa fecha.
   * @returns Clave i18n de la leyenda del periodo.
   */
  getPlanPeriodKey(): string {
    const subscription = this.user ? this.user.subscription : null;
    return subscription && subscription.cancel_at_period_end
      ? "topbar.profile.cancels-on"
      : "topbar.profile.renews-on";
  }
  validateImageOrganization(user) {
    if (user.client && user.client.organization) {
      return user.client.organization.logo;
    }
    return "";
  }
  validateImage(user) {
    if (user.is_subclient && user.subclient.logo) {
      return user.subclient.logo;
    }
    if (!user.is_subclient && user.client && user.client.logo) {
      return user.client.logo;
    }
    return "";
  }
}
